import { LineChartWebElementBase } from './LineChartWebElementBase';

/**
 * The component WebElement for [oj-c-line-chart](../../jsdocs/oj-c.LineChart.html).
 * Do not instantiate this class directly, instead, use
 * [findLineChart](../functions/findLineChart.html).
 */
export class LineChartWebElement extends LineChartWebElementBase {
  // Put overrides here
}
